<div class="flex-col">
  <div class="error-title">
    {{ 'ERROR_DIALOG.TEXT.DIALOG_TITLE' | translate }}
  </div>

  <div class="flex-col error-content">
    <div class="message-text">{{ data.message }}</div>

    <div class="message-text" *ngFor="let error of data.errors">
      {{ error.message }}
    </div>

    <div class="flex-row justify-around">
      <button
        type="button"
        class="confirmation-button"
        mat-flat-button
        (click)="closeDialog()"
      >
        {{ 'ERROR_DIALOG.BUTTON.OK' | translate }}
      </button>
    </div>
  </div>
</div>
